import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModelWithUser } from './base';
import { EInsuranceVerificationStatus } from './insurance';
import { EModel } from './model';
export let EInsuranceVerificationVerificationStatus;
(function (EInsuranceVerificationVerificationStatus) {
  EInsuranceVerificationVerificationStatus["Unknown"] = "unknown";
  EInsuranceVerificationVerificationStatus["Active"] = "active";
  EInsuranceVerificationVerificationStatus["Inactive"] = "inactive";
  EInsuranceVerificationVerificationStatus["Failed"] = "failed";
})(EInsuranceVerificationVerificationStatus || (EInsuranceVerificationVerificationStatus = {}));
export const fieldsInsuranceVerification = _extends({}, fieldsIBaseModelWithUser, {
  benefitsInformation: {
    type: 'Object',
    array: true
  },
  insurance: {
    type: 'ID',
    ref: EModel.Insurance
  },
  lookupResults: {
    type: 'Unknown'
  },
  patient: {
    type: 'ID',
    ref: EModel.Patient
  },
  requestedBy: {
    type: 'ID',
    ref: EModel.User
  },
  status: {
    type: 'Option',
    values: EInsuranceVerificationStatus
  }
});